import forDevice from '../../hoc/for-device';
import CategoryDropdownSelectMobile from './category-dropdown-select-mobile';
import CategoryDropdownSelectDesktop from './category-dropdown-select-desktop';

export default forDevice(CategoryDropdownSelectMobile, CategoryDropdownSelectDesktop);
